import { connect } from 'react-redux';

import { IState } from '../../store';

import { getOfferType, isCommercial as checkIsCommercial } from '../../../shared/utils/offer_type';
import { getCustomUrl } from '../../utils/tracking';
import { IPriceHistoryProps, PriceHistory } from './index';
import { getTitle, getDealType, getValuation } from './utils';

export function mapStateToProps(state: IState): IPriceHistoryProps {
  const {
    offerData: { offer, agent, priceChanges, costEstimationData },
  } = state;

  const offerType = getOfferType(offer);
  // Коммерческой историей изменения цены в объявке, которая:
  // - имеет тип коммерческая
  // - не имеет цены в виде целого числа (вместо этого от-до)
  // - не является коммерческой землей
  /* istanbul ignore next */
  const isCommercial = Boolean(checkIsCommercial(offerType) && offer.canParts);

  return {
    customURL: getCustomUrl(offer, agent),
    events: priceChanges || [],
    title: getTitle(offer.dealType, isCommercial),
    dealType: getDealType(offer),
    valuation: getValuation(offer, costEstimationData),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PriceHistoryContainer = connect<IPriceHistoryProps, any, any>(mapStateToProps)(PriceHistory);
